<template>
    <div
        tabindex="0"
        class="FlagSelect"
        @focusout="hideSelect"
    >
        <div
            class="FlagSelect-selected"
            :aria-label="$t('personal-account.flagSelect.selectedCountry')"
            @click="toggleSelect"
            @keyup.enter="toggleSelect"
        >
            <Flag
                :country="country"
                class="FlagSelect-selectedFlag"
            />
        </div>
        <div
            v-if="showCountries"
            class="FlagSelect-optionsContainer"
        >
            <input-options
                :avoidFocus="true"
                :isOptionsOpen="true"
                :items="items"
                :optionsObject="false"
                :value="items"
                :withSlotItem="true"
                @input="optionChanged"
            >
                <template #option="{item}">
                    <div class="FlagSelect-option">
                        <Flag :country="item.split('-')[1]" />
                        <span class="FlagSelect-countryName">{{ $t('personal-account.flagSelect.selectACountry.' + item) }}</span>
                    </div>
                </template>
            </input-options>
        </div>
    </div>
</template>
<script>
import Flag from './Flag.vue';
import InputOptions from '@/components/InputOptions.vue'
import {countries} from '@/constants/countries';

export default {
    components: {
        Flag,
        InputOptions
    },
    props: {
        country: {
            type: String,
            default: () => ('')
        }
    },
    data() {
        return {
            showCountries: false,
            items: countries,
        }
    },
    methods: {
        optionChanged(selectedIndex) {
            this.$emit('flagSelected', this.items[selectedIndex]);
        },
        toggleSelect() {
            this.showCountries = !this.showCountries;
        },
        hideSelect(e) {
            e.preventDefault();
            if(!this.$el.contains(e.relatedTarget))
                this.showCountries = false;
        }
    }
}
</script>
<style lang="scss" scoped>
.FlagSelect {
    position: relative;

    &-selectedFlag{
        cursor: pointer;
    }

    &-optionsContainer {
        position: absolute;
        right: 0;
        width: 200px;
        margin-top: 10px;
        @media (max-width: $f2m-desktop-breakpoint) {
            width: calc(100vw - 232px);
            right: unset;
        }
    }
    &-option {
        display: flex;
        align-items: center;
        gap: 10px;
    }
    &-countryName {
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        max-width: 150px;
    }
}

</style>
